<template>
  <div class="banner" :style="isMobile() ? 'justify-content: flex-end;' : ''">
    <div class="toggleBtn" v-if="!isMobile()" @click="toggleCollapse">
      <el-icon size="20" color="#606266">
        <Expand v-if="props.isCollapse" />
        <Fold v-else />
      </el-icon>
      <span class="header-title" v-if="sliderStore.navParTitle"
        >{{ $t(sliderStore.navParTitle) }}&nbsp;&nbsp;/
      </span>
      <span class="header-title">{{ $t(sliderStore.navTitle) }}</span>
      <!-- <span class="header-title">{{ $t(navTitle) }}</span> -->
    </div>
    <!-- <div class="flex" style="align-items: center">
      <img src="/src/assets/logo@2x.png" style="width: 1.5rem; height: 1.5rem" alt="" />
      <span style="font-size: 13px; margin-left: 5px">{{ $t('t_to_login') }}</span>
    </div> -->
    <div class="user-info">
      <!-- <el-dropdown> -->
      <div class="el-dropdown-link">
        <!-- handlePopClick -->
        <leftChatModal :collapse="true" placement="bottom" ref="leftChatModalRef" />
        <div class="left-chat-avatar" @click="handlePopClick">
          <el-popover
            v-if="useUserStore().nickName.length > 6"
            :width="200"
            trigger="hover"
            placement="left"
            :content="useUserStore().nickName"
          >
            <template #reference>
              <div class="user-nick-name" :style="isMobile() ? 'max-width:17vw' : 'max-width:20vw'">
                {{ useUserStore().nickName }}
              </div>
            </template>
            <!-- :style="isCollapse ? 'max-width:3.3vw' : 'max-width:6vw'" -->
          </el-popover>
          <div
            class="user-nick-name"
            :style="isMobile() ? 'max-width:17vw' : 'max-width:20vw'"
            v-else
          >
            <!-- :style="isCollapse ? 'max-width:3.3vw' : 'max-width:5vw'" -->
            {{ useUserStore().nickName }}
          </div>
        </div>
        <el-icon class="el-icon--right" @click="handlePopClick"><arrow-down /></el-icon>
      </div>
      <!-- <template #dropdown> </template> -->
      <!-- </el-dropdown> -->
    </div>
  </div>
</template>
<script lang="ts" setup>
import { defineEmits, defineProps, ref, getCurrentInstance, watch } from 'vue'
import { useSliderStore, useChatListStore, useUserStore, useWebSocketStore } from '@/stores'
import leftChatModal from '@/views/customer/component/left-chat-modal.vue'
import { useRoute } from 'vue-router'
import {
  ArrowDown,
  Check,
  CircleCheck,
  CirclePlus,
  CirclePlusFilled,
  Plus
} from '@element-plus/icons-vue'
import { onMounted } from 'vue'
const emits = defineEmits(['toggleCollapse'])
const sliderStore = useSliderStore()
const { $t } = getCurrentInstance()?.appContext.config.globalProperties

const toggleCollapse = () => {
  emits('toggleCollapse')
}
const leftChatModalRef = ref()
const props = defineProps({
  isCollapse: {
    type: Boolean,
    default: false
  }
})
const handlePopClick = () => {
  leftChatModalRef.value.handlePopClick()
}
const isMobile = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera
  // |ipad
  let flag = /android|webos|iphone|ipod|blackberry|iemobile|opera mini/i.test(userAgent)
  return flag
}
// const navTitle = ref()
// onMounted(() => {
//   const route = useRoute() // 获取当前路由信息
//   console.log(route, 'route')
//   alert(route.meta.languageKey)
//   navTitle.value = route.meta?.languageKey ?? ''
// })
</script>
<style scoped lang="scss">
.user-nick-name {
  cursor: pointer;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.banner {
  background: #fff;
  // margin-bottom: 6px;
  height: 46px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  color: #606266;
  padding: 10px;
  .toggleBtn {
    display: flex;
    align-items: center;
    .header-title {
      padding-left: 10px;
      font-size: 14px;
    }
  }
  .left-chat-avatar {
    margin-left: 5px;
    margin-right: 10px;
  }
}
.el-dropdown-link {
  display: flex;
  align-items: center;
}
.el-dropdown-link:focus {
  outline: none;
}
</style>
